export const millisecondsToSeconds = (ms: number) =>
    Math.floor(ms / 1000);

export const minutesToHours = (minutes: number) =>
    Math.floor(minutes / 60);

export const secondsToMinutes = (seconds: number) =>
    Math.floor(seconds / 60);
